document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.getElementById('mobile-menu');
  if (!drawer || drawer.querySelector('.blacksmith-mobile-menu__country-bar')) return;

  var localizationForm = drawer.querySelector('.thb-mobile-menu-footer .thb-localization-forms');
  if (!localizationForm) return;

  var countrySelect = localizationForm.querySelector('select[name="country_code"]');
  if (!countrySelect) return;

  var appendedAbout = drawer.querySelector('[data-blacksmith-about-us]');
  if (appendedAbout) appendedAbout.remove();

  drawer.querySelectorAll('.blacksmith-mobile-menu__origin').forEach(function (origin) {
    origin.remove();
  });

  var primaryMenu = drawer.querySelector('.mobile-menu');
  if (primaryMenu) {
    Array.prototype.forEach.call(primaryMenu.children, function (item) {
      var label = item.textContent.replace(/\s+/g, ' ').trim();
      item.style.display = label.indexOf('Shop') === 0 || label.indexOf('Explore') === 0 ? '' : 'none';
    });
  }

  var utilityLinks = drawer.querySelector('.blacksmith-mobile-menu__utilities');
  if (!utilityLinks) {
    utilityLinks = document.createElement('nav');
    utilityLinks.className = 'blacksmith-mobile-menu__utilities';
    utilityLinks.setAttribute('aria-label', 'Secondary navigation');
    if (primaryMenu) primaryMenu.insertAdjacentElement('afterend', utilityLinks);
  }

  utilityLinks.innerHTML =
    '<a href="/pages/about-us">About Us</a>' +
    '<a href="/pages/contact-us#visit-us">Visit Us</a>' +
    '<a href="/pages/contact-us">Contact Us</a>' +
    '<a href="/pages/faqs">FAQ\'s</a>' +
    '<a href="/account">My Account</a>' +
    '<a href="/products/gift-cards">E-Gift Cards</a>';

  var style = document.createElement('style');
  style.id = 'blacksmith-mobile-country-selector-styles';
  style.textContent =
    '@media only screen and (max-width:1067px){' +
      '.blacksmith-mobile-menu .mobile-menu>li>.link-container,' +
      '.blacksmith-mobile-menu .mobile-menu>li>.link-container .parent-link,' +
      '.blacksmith-mobile-menu .mobile-menu>li>.link-container .parent-link a{' +
        'color:#fff!important;' +
        'font-size:clamp(1.3rem,6vw,1.65rem)!important;' +
        'font-weight:var(--font-body-bold-weight,600)!important;' +
        'letter-spacing:.025em!important;' +
      '}' +
      '.blacksmith-mobile-menu__utilities{' +
        'display:block!important;margin:0 20px!important;padding:0!important;border-top:0!important;' +
      '}' +
      '.blacksmith-mobile-menu__utilities a{' +
        'display:flex!important;align-items:center!important;min-height:50px!important;padding:5px 0!important;' +
        'border-bottom:1px solid rgba(255,255,255,.14)!important;color:rgba(255,255,255,.56)!important;' +
        'font-size:14px;font-weight:var(--font-body-bold-weight,600)!important;' +
        'letter-spacing:.025em!important;line-height:1.2!important;' +
      '}' +
      '.blacksmith-mobile-menu__country-bar{' +
        'position:relative!important;z-index:4!important;display:flex!important;align-items:center!important;' +
        'min-height:48px!important;margin:10px 18px 0!important;padding:0 0 0!important;' +
      '}' +
      '.blacksmith-mobile-menu__country-bar .thb-localization-forms{' +
        'display:block!important;margin:0!important;padding:0!important;border:0!important;background:transparent!important;' +
      '}' +
      '.blacksmith-mobile-menu__country-bar form{' +
        'display:block!important;margin:0!important;padding:0!important;' +
      '}' +
      '.blacksmith-mobile-menu__country-control{' +
        'position:relative!important;display:inline-flex!important;align-items:center!important;min-height:48px!important;' +
        'color:#fff!important;cursor:pointer!important;' +
      '}' +
      '.blacksmith-mobile-menu__country-display{' +
        'display:inline-flex!important;align-items:center!important;gap:9px!important;color:#fff!important;' +
        'font-size:1rem!important;line-height:1!important;pointer-events:none!important;' +
      '}' +
      '.blacksmith-mobile-menu__country-flag{' +
        'display:block!important;width:28px!important;height:19px!important;object-fit:cover!important;border-radius:2px!important;' +
      '}' +
      '.blacksmith-mobile-menu__country-chevron{' +
        'display:block!important;width:8px!important;height:8px!important;margin-left:2px!important;' +
        'border-right:2px solid currentColor!important;border-bottom:2px solid currentColor!important;' +
        'transform:translateY(-2px) rotate(45deg)!important;' +
      '}' +
      '.blacksmith-mobile-menu__country-control select{' +
        'position:absolute!important;inset:0!important;width:100%!important;height:100%!important;' +
        'margin:0!important;padding:0!important;opacity:0!important;cursor:pointer!important;z-index:2!important;' +
      '}' +
      '.blacksmith-mobile-menu__country-control .select-arrow,' +
      '.blacksmith-mobile-menu__country-control label{' +
        'display:none!important;' +
      '}' +
      '@media only screen and (max-width:420px){' +
        '.blacksmith-mobile-menu__utilities{margin-right:16px!important;margin-left:16px!important;}' +
        '.blacksmith-mobile-menu__country-bar{margin-right:16px!important;margin-left:16px!important;}' +
      '}' +
    '}';
  document.head.appendChild(style);

  var bar = document.createElement('div');
  bar.className = 'blacksmith-mobile-menu__country-bar';

  var control = document.createElement('div');
  control.className = 'blacksmith-mobile-menu__country-control';

  var display = document.createElement('span');
  display.className = 'blacksmith-mobile-menu__country-display';
  display.setAttribute('aria-hidden', 'true');

  function updateDisplay() {
    var option = countrySelect.options[countrySelect.selectedIndex];
    var countryCode = (countrySelect.value || 'AU').toLowerCase();
    var currencyCode = option && option.dataset && option.dataset.currencyCode
      ? option.dataset.currencyCode
      : ((option && option.textContent.match(/\b[A-Z]{3}\b/)) || ['AUD'])[0];

    display.innerHTML =
      '<img class="blacksmith-mobile-menu__country-flag" src="https://flagcdn.com/w80/' + countryCode + '.png" alt="">' +
      '<span class="blacksmith-mobile-menu__country-code">' + currencyCode + '</span>' +
      '<span class="blacksmith-mobile-menu__country-chevron"></span>';
  }

  updateDisplay();
  countrySelect.addEventListener('change', updateDisplay);

  var selectWrapper = countrySelect.closest('.select') || countrySelect.parentElement;
  control.appendChild(display);
  if (selectWrapper) {
    control.appendChild(selectWrapper);
  } else {
    control.appendChild(countrySelect);
  }

  bar.appendChild(control);
  utilityLinks.insertAdjacentElement('afterend', bar);
});
